import React from "react";
import "./Logo.css";
const Logo = ({ id }) => {
  return (
    <h1 id={id || ""}>
      <span className="Air">Air</span>
      <span className="Book">Book</span>
    </h1>
  );
};

export default Logo;
